module.exports = __webpack_public_path__ + "img/30290-1-132.prt.5466074e.jpg";